import styled from "styled-components";

export const SubscriptionStyled = {
  HeroSection: styled.div`
    position: relative;
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    background: linear-gradient(90deg, #cd3ec7 0%, #5328df 50%, #2d8efa 100%);
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    .title-area {
      h3 {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
      }
      h2 {
        font-size: 24px;
        font-style: normal;
        font-weight: 800;
        line-height: 32px; /* 133.333% */
        letter-spacing: -0.48px;
        margin-top: 4px;
      }
    }
    .desc {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: -0.28px;
    }
    .icons {
      margin-top: 16px;
      display: flex;
      align-items: flex-start;
      align-content: flex-start;
      gap: 12px;
      align-self: stretch;
      flex-wrap: wrap;
      .icon-item {
        display: flex;
        height: 32px;
        padding: 0 16px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 16px;
        border: 1px solid #fff;
      }
    }
    img {
      position: absolute;
      right: 24px;
      top: 16px;
    }
    * {
      color: #fff;
    }
  `,
  UsedProductSection: styled.div`
    display: flex;
    padding: 24px 24px 0 24px;
    flex-direction: column;
    gap: 16px;
    align-self: stretch;
    h3 {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px; /* 140% */
      letter-spacing: -0.4px;
    }
    .product-list {
      display: flex;
      flex-direction: column;
      gap: 16px;
      .product-card {
        display: flex;
        padding: 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 16px;
        background: linear-gradient(180deg, #825ae7 0%, #4d73e7 100%);
        box-shadow: 0 6px 12px -6px rgba(0, 0, 0, 0.04),
          0 8px 24px -4px rgba(0, 0, 0, 0.04);
        &.purple {
          background: #6d2ef2;
        }
        &.black {
          background: #212121;
        }
        .badge {
          display: flex;
          height: 20px;
          min-height: 20px;
          padding: 0 8px;
          justify-content: center;
          align-items: center;
          gap: 8px;
          color: #6d2ef2;
          text-align: center;
          font-family: Pretendard;
          font-size: 10px;
          font-weight: 500;
          line-height: 16px; /* 160% */
          letter-spacing: -0.2px;
          border-radius: 20px;
          background: #fff;
          &.red {
            background: #f40;
            color: #fff;
          }
        }
        .product-title {
          color: #fff;
          font-size: 20px;
          font-weight: 700;
          line-height: 26px; /* 130% */
        }
        .kv-item {
          display: flex;
          > div {
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.36px;
            color: #fff;
          }
          > div:first-child {
            width: 72px;
          }
        }
        .payment-area {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding-top: 8px;
          margin-top: 8px;
          align-items: center;
          border-top: 1px solid #fff;
          div {
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.36px;
            color: #fff;
          }
          .amt {
            font-size: 20px;
            font-weight: 700;
            line-height: 140%; /* 28px */
          }
        }
        .error-msg {
          display: flex;
          align-items: center;
          gap: 2px;
          margin-bottom: 8px;
          svg {
            color: #f40;
          }
          color: #f40;
          > :last-child {
            font-size: 12px;
            font-weight: 400;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.24px;
          }
        }
        .manage-btn {
          background: #6d2ef2;
          border-radius: 4px;
          display: flex;
          height: 32px;
          justify-content: center;
          align-items: center;
          width: 100%;
          font-size: 14px;
          color: #fff;
          font-weight: 600;
          line-height: 20px; /* 142.857% */
          letter-spacing: -0.28px;
        }
      }
    }
  `,
  AllProductSection: styled.div`
    display: flex;
    padding: 24px 24px 0 24px;
    flex-direction: column;
    gap: 16px;
    align-self: stretch;
    h3 {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px; /* 140% */
      letter-spacing: -0.4px;
    }
    .product-list {
      display: flex;
      flex-direction: column;
      gap: 16px;
      .product-card {
        display: flex;
        padding: 24px;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        border-radius: 16px;
        border: 1px solid #eee;
        .product-title,
        .price {
          color: #666;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px; /* 150% */
        }
        .badge {
          color: #fff;
          text-align: center;
          font-size: 10px;
          font-style: normal;
          font-weight: 500;
          line-height: 16px; /* 160% */
          letter-spacing: -0.2px;
          border-radius: 20px;
          background: #6d2ef2;
          display: flex;
          min-height: 20px;
          padding: 0 8px;
          justify-content: center;
          align-items: center;
          margin-bottom: 8px;
          &.outlined {
            border: 1px solid #6d2ef2 !important;
            background: transparent !important;
            color: #6d2ef2;
          }
        }
        &.selected {
          border-color: #6d2ef2;
          .price {
            color: #6d2ef2 !important;
          }
        }
        .desc {
          margin-top: 8px;
          color: #888;
          font-size: 11px;
          font-weight: 400;
          line-height: 14px; /* 127.273% */
          letter-spacing: -0.22px;
        }
        .free-area {
          width: 100%;
          margin-top: 24px;
          padding: 12px 24px;
          background: #f8f5fe;
          margin-left: -24px !important;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            > div:first-child {
              color: #6d2ef2;
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: 16px; /* 133.333% */
              letter-spacing: -0.36px;
            }
            > div:last-child {
              color: #555;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px; /* 133.333% */
              letter-spacing: -0.24px;
              margin-top: 2px;
            }
          }
          .badge {
            margin-bottom: 0;
          }
        }
        .sub-desc-area {
          margin-top: 24px;
          > div:first-child {
            color: #555;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.36px;
          }
          > div:last-child {
            color: #666;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.24px;
          }
        }
      }
    }
  `,
  QnaSection: styled.div`
    padding: 24px;
    h3 {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px; /* 140% */
      letter-spacing: -0.4px;
    }
    .question-list {
      margin-top: 16px;
      .question-item {
        cursor: pointer;
        border-top: 1px solid #eee;
        .question {
          padding: 12px 0;
          display: flex;
          justify-content: space-between;
          > span:first-child {
            color: #212121;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            letter-spacing: -0.28px;
          }
          > span:last-child svg {
            rotate: 90deg;
          }
        }
        .answer {
          display: none;
          background: #f7f7f7;
          color: #888;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 133.333% */
          letter-spacing: -0.24px;
          padding: 12px;
        }
        strong {
          color: #333333;
          font-weight: 600;
        }
        &.is-selected {
          svg {
            rotate: 270deg !important;
          }
          .answer {
            display: block !important;
          }
        }
      }
    }
  `,
  AgreementSection: styled.div`
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    background: #f7f7f7;
    .desc {
      color: #666;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px; /* 133.333% */
      letter-spacing: -0.24px;
    }
    .checkbox-area {
      display: flex;
      align-items: center;
      gap: 6px;
      width: 100%;
      .checkbox {
        color: #6d2ef2 !important;
        &.MuiCheckbox-root {
          color: #6d2ef2 !important;
          padding: 0 !important;
        }
        .MuiSvgIcon-root {
          color: #6d2ef2 !important;
        }
        &.Mui-checked {
          color: #6d2ef2 !important;
        }
      }
      .label {
        color: #212121;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 138.462% */
      }
    }
  `,
  Footer: styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    gap: 10px;
    border-top: 1px solid #f0f0f0;
    background: white;
    flex-shrink: 0;
    .selected-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item-name {
        color: #212121;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
      }
      .item-price {
        color: #6d2ef2;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px; /* 140% */
      }
    }
    .purchase-btn {
      display: flex;
      height: 48px;
      width: 100%;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 24px;
      background: linear-gradient(90deg, #cd3ec7 0%, #5328df 50%, #2d8efa 100%);
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
      letter-spacing: -0.32px;
      &:disabled,
      &.disabled {
        background: #eee;
        color: #888;
        font-weight: 500;
        cursor: not-allowed;
      }
    }
  `,
};

export const SubscriptionCompleteStyled = {
  Container: styled.div`
    padding: 24px 16px;
    .title-area {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 8px;
      text-align: center;
      margin: 0 auto;
      .img {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .main-img {
        position: relative;
        .check-img {
          position: absolute;
          right: 8px;
          bottom: 8px;
          display: flex;
          width: 48px;
          height: 48px;
          justify-content: center;
          align-items: center;
          border-radius: 33554400px;
          background: linear-gradient(
            90deg,
            #cd3ec7 0%,
            #5328df 50%,
            #2d8efa 100%
          );
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -4px rgba(0, 0, 0, 0.1);
        }
      }
      h3 {
        color: #212121;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px; /* 140% */
        letter-spacing: -0.4px;
      }
      .desc {
        color: #666;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.28px;
      }
    }
    .product-area {
      margin-top: 16px;
      padding: 24px 24px 16px 24px;
      border-radius: 16px;
      border: 1px solid #c5abfa;
      background: #f8f5fe;
      .badge {
        padding: 0 8px;
        border-radius: 20px;
        border: 1px solid #6d2ef2;
        margin-bottom: 8px;
        color: #6d2ef2;
        font-size: 10px;
        font-weight: 500;
        line-height: 16px; /* 160% */
        letter-spacing: -0.2px;
        display: flex;
        height: 20px;
        justify-content: center;
        align-items: center;
        width: max-content;
      }
      .product-title {
        color: #212121;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
      }
      .price {
        color: #6d2ef2;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
      }
      .sub {
        margin-top: 20px;
        .kv {
          display: flex;
          padding: 4px 0;
          > :first-child {
            width: 72px;
            color: #555;
            font-size: 12px;
            font-weight: 600;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.36px;
          }
          > :last-child {
            color: #666;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px; /* 133.333% */
            letter-spacing: -0.24px;
          }
          &.purple {
            > span {
              color: #6d2ef2;
            }
          }
        }
      }
    }
    .desc-area {
      margin-top: 16px;
      color: #6d2ef2;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px; /* 142.857% */
      letter-spacing: -0.28px;
    }
    .gradient-btn {
      margin-top: 40px;
    }
  `,
};
